<template>
  <div class="warrantStatistical" v-if="permisShow('权证统计')">
    <ul class="dataList">
      <li class="dataList_item1">
        <div class="item_time">
          <el-date-picker v-model="time" @change="getWarrantStatistics()" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份">
          </el-date-picker>
          <!-- {{time}} -->
          <!-- <el-select v-model="data.year" placeholder="请选择" @change="getWarrantStatistics()">
            <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <span class="item_time_unit">年</span>
          <el-select v-model="data.month" placeholder="请选择" @change="getWarrantStatistics()">
            <el-option v-for="(item,index) in options1" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
          <!-- <span class="item_time_unit">月</span> -->
        </div>
        <ul class="item_list">
          <li class="list_item_one">
            <div class="one_text">
              <p class="text_number">{{warrantStatisticsDTO.warrantNumber}}</p>
              <p class="text_unit">权证收件数（个）</p>
            </div>
          </li>
          <li class="list_item_two">
            <div class="one_text">
              <p class="text_number">{{warrantStatisticsDTO.notNumber}}</p>
              <p class="text_unit">未办理数（个）</p>
            </div>
          </li>
          <li class="list_item_three">
            <div class="one_text">
              <p class="text_number">{{warrantStatisticsDTO.dealingNumber}}</p>
              <p class="text_unit">办理中（个）</p>
            </div>
          </li>
          <li class="list_item_four">
            <div class="one_text">
              <p class="text_number">{{warrantStatisticsDTO.completeNumber}}</p>
              <p class="text_unit">办理完结（个）</p>
            </div>
          </li>
          <li class="list_item_five">
            <div class="one_text">
              <p class="text_number">{{warrantStatisticsDTO.endNumber}}</p>
              <p class="text_unit">终止过户（个）</p>
            </div>
          </li>
        </ul>
      </li>
      <li class="dataList_item2">
        <div class="tiao"></div>
        <ul class="wrap">
          <li class="wrap_item">
            <template>
              <ve-pie :data="transferList" :extend="chartExtend" height="370px"></ve-pie>
              <h3>过户类型</h3>
            </template>
          </li>
          <li class="wrap_item">
            <template>
              <ve-pie :data="bankList" :extend="chartExtend" height="370px"></ve-pie>
              <h3>贷款银行</h3>
            </template>
          </li>
          <li class="wrap_item">
            <template>
              <ve-histogram :data="allMoney" :extend="chartExtendline1" height="370px" :settings="allMoneyset">
              </ve-histogram>
              <h3>贷款/放款总金额</h3>
            </template>
          </li>
        </ul>
        <div class="tiao1"></div>
      </li>
      <li class="dataList_item3">
        <h3>权证办理情况</h3>
        <template>
          <ve-line :data="warrantDtoList" :extend="chartExtendline" :settings="warrantDtoListset" width="100%"></ve-line>
        </template>
      </li>
      <li class="dataList_item4">
        <h3>各银行贷款总额</h3>
        <template>
          <ve-line :data="bankListData" :extend="chartExtendline" :settings="bankListDataset" width="100%"></ve-line>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  queryWarrantStatistics,
  queryYearWarrantStatistics
} from "@/api/warrantStatistical";
export default {
  data() {
    let date = new Date();
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    this.chartExtend = {
      legend: {
        top: "20px"
      },
      series: {
        center: ["50%", "50%"]
      }
    };
    this.chartExtendline = {
      legend: {
        top: "5%"
      },
      grid: {
        x: 10,
        y: 60
      }
    };
    this.chartExtendline1 = {
      "xAxis.0.axisLabel.rotate": 45,
      legend: {
        top: "5%"
      },
      grid: {
        x: 20,
        y: 60
      }
    };
    this.allMoneyset = {
      labelMap: {
        money: "贷款总金额",
        lentingTimeMoney: "放款总金额"
      },
      yAxisName: ["万元"]
    };
    this.warrantDtoListset = {
      labelMap: {
        warrantNumber: "权证",
        dealingNumber: "办理中",
        completeNumber: "已完成"
      }
    };
    this.bankListDataset = {
      labelMap: {
        icbc: "中国工商银行",
        ccb: "中国建设银行",
        china: "中国银行",
        abc: "中国农业银行",
        boc: "交通银行",
        cmb: "招商银行",
        psbc: "中国邮政银行",
        zjbc: "珠江银行"
      },
      yAxisName: ["万元"]
    };
    return {
      permisList,
      warrantStatisticsDTO: {}, //数量统计
      bankList: {
        columns: ["type", "number"],
        rows: []
      }, //银行
      transferList: {
        columns: ["type", "number"],
        rows: []
      }, //过户类型
      allMoney: {
        columns: ["type", "money", "lentingTimeMoney"],
        rows: []
      },
      bankListData: {
        columns: [
          "yearMonth",
          "icbc",
          "ccb",
          "china",
          "abc",
          "boc",
          "cmb",
          "psbc",
          "zjbc"
        ],
        rows: []
      },
      warrantDtoList: {
        columns: [
          "yearMonth",
          "warrantNumber",
          "dealingNumber",
          "completeNumber"
        ],
        rows: []
      },
      // data: {
      //   year: date.getFullYear(), //年
      //   month:
      //     date.getMonth() + 1 < 10
      //       ? "0" + (date.getMonth() + 1)
      //       : date.getMonth() + 1 //月
      // },
      time: [
        date.getFullYear() + "-" + (date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "-01",
        date.getFullYear() + "-" + (date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "-" + (date.getDate() >= 10 ? date.getDate() : "0" + date.getDate())
      ],
      options: [
        {
          value: "2019",
          label: "2019"
        },
        {
          value: "2020",
          label: "2020"
        },
        {
          value: "2021",
          label: "2021"
        },
        {
          value: "2022",
          label: "2022"
        },
        {
          value: "2023",
          label: "2023"
        },
        {
          value: "2024",
          label: "2024"
        },
        {
          value: "2025",
          label: "2025"
        },
        {
          value: "2026",
          label: "2026"
        },
        {
          value: "2027",
          label: "2027"
        },
        {
          value: "2028",
          label: "2028"
        }
      ],
      options1: [
        {
          value: "",
          label: "不限"
        },
        {
          value: "01",
          label: "1"
        },
        {
          value: "02",
          label: "2"
        },
        {
          value: "03",
          label: "3"
        },
        {
          value: "04",
          label: "4"
        },
        {
          value: "05",
          label: "5"
        },
        {
          value: "06",
          label: "6"
        },
        {
          value: "07",
          label: "7"
        },
        {
          value: "08",
          label: "8"
        },
        {
          value: "09",
          label: "9"
        },
        {
          value: "10",
          label: "10"
        },
        {
          value: "11",
          label: "11"
        },
        {
          value: "12",
          label: "12"
        }
      ]
    };
  },
  mounted() {
    this.getWarrantStatistics(); //查询金额银行
    this.getYearWarrantStatistics(); //查询金额银行
  },

  methods: {
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },
    getWarrantStatistics() {
      let params = {
        // year: this.data.year,
        // month: this.data.month
        date: this.time
      };
      this.$post(queryWarrantStatistics, params).then(res => {
        if (res.success) {
          this.warrantStatisticsDTO = res.data.warrantStatisticsDTO;
          this.bankList.rows = res.data.bankList;
          this.allMoney.rows = res.data.bankList;
          this.transferList.rows = res.data.transferList;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
            duration: 1000
          });
        }
      });
    },
    getYearWarrantStatistics() {
      this.$post(queryYearWarrantStatistics).then(res => {
        if (res.success) {
          this.bankListData.rows = res.data.bankList;
          this.warrantDtoList.rows = res.data.warrantDtoList;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
            duration: 1000
          });
        }
      });
    }
  }
};
</script>

<style lang='less'>
.warrantStatistical {
  width: 100%;
  .dataList {
    padding: 14px;
    .dataList_item1 {
      background: #fff;
      overflow: hidden;
      padding: 25px 20px;
      .item_time {
        padding-bottom: 24px;
        .el-date-editor {
          line-height: 30px;
          height: 30px;
        }
        .el-select {
          .el-input {
            width: 100px;
            .el-input__inner {
              height: 30px;
              background: #f5f5f5;
              border: none;
            }
            .el-input__icon {
              line-height: 30px;
            }
          }
        }
        .item_time_unit {
          padding: 0 10px;
        }
      }
      .item_list {
        display: flex;
        justify-content: space-between;
        .list_item_one {
          flex: 1;
          border-left: 5px solid #ffffff;
          border-right: 5px solid #ffffff;
          height: 110px;
          background: url(../../assets/statisticalManage/quan-01.png) no-repeat;
          background-size: cover;
          border-radius: 6px;
          .one_text {
            width: 122px;
            position: relative;
            padding-top: 32px;
            margin: 0 auto;
            color: #fff;
            .text_number {
              font-size: 20px;
              margin-bottom: 10px;
            }
            .text_unit {
              font-size: 15px;
            }
          }
        }
        .list_item_two {
          flex: 1;
          border-left: 5px solid #ffffff;
          border-right: 5px solid #ffffff;
          height: 110px;
          background: url(../../assets/statisticalManage/quan-02.png) no-repeat;
          background-size: cover;
          border-radius: 6px;
          .one_text {
            width: 122px;
            position: relative;
            padding-top: 32px;
            margin: 0 auto;
            color: #fff;
            .text_number {
              font-size: 20px;
              margin-bottom: 10px;
            }
            .text_unit {
              font-size: 15px;
            }
          }
        }
        .list_item_three {
          flex: 1;
          border-left: 5px solid #ffffff;
          border-right: 5px solid #ffffff;
          height: 110px;
          background: url(../../assets/statisticalManage/quan-03.png) no-repeat;
          background-size: cover;
          border-radius: 6px;
          .one_text {
            width: 122px;
            position: relative;
            padding-top: 32px;
            margin: 0 auto;
            color: #fff;
            .text_number {
              font-size: 20px;
              margin-bottom: 10px;
            }
            .text_unit {
              font-size: 15px;
            }
          }
        }
        .list_item_four {
          flex: 1;
          border-left: 5px solid #ffffff;
          border-right: 5px solid #ffffff;
          height: 110px;
          background: url(../../assets/statisticalManage/quan-04.png) no-repeat;
          background-size: cover;
          border-radius: 6px;
          .one_text {
            width: 122px;
            position: relative;
            padding-top: 32px;
            margin: 0 auto;
            color: #fff;
            .text_number {
              font-size: 20px;
              margin-bottom: 10px;
            }
            .text_unit {
              font-size: 15px;
            }
          }
        }
        .list_item_five {
          flex: 1;
          border-left: 5px solid #ffffff;
          border-right: 5px solid #ffffff;
          height: 110px;
          background: url(../../assets/statisticalManage/quan-05.png) no-repeat;
          background-size: cover;
          border-radius: 6px;
          .one_text {
            width: 122px;
            position: relative;
            padding-top: 32px;
            margin: 0 auto;
            color: #fff;
            .text_number {
              font-size: 20px;
              margin-bottom: 10px;
            }
            .text_unit {
              font-size: 15px;
            }
          }
        }
      }
    }
    .dataList_item2 {
      position: relative;
      .tiao {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 100%;
        background: #fff;
      }
      .tiao1 {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 20px;
        width: 100%;
        background: #fff;
      }
      .wrap {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        .wrap_item {
          background: #fff;
          width: 32.8%;
          overflow: hidden;
          h3 {
            text-align: center;
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 30px;
          }
        }
      }
    }
    .dataList_item3 {
      margin-top: 10px;
      padding: 20px;
      background: #fff;
      h3 {
        font-size: 16px;
        padding-bottom: 20px;
        font-weight: bold;
        border-bottom: 1px solid #e1e1e1;
      }
    }
    .dataList_item4 {
      margin-top: 10px;
      padding: 20px;
      background: #fff;
      h3 {
        font-size: 16px;
        padding-bottom: 20px;
        font-weight: bold;
        border-bottom: 1px solid #e1e1e1;
      }
    }
  }
}
</style>